import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const forgotPasswordSendOtpApi = createAsyncThunk(
  "user/forgotPasswordSendOtp",
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/users/forgot-password/send-otp",
        emailData,
      );
      return response.data;
    } catch (error) {
      console.error("ForgotPasswordSendOtp API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to send OTP",
        );
      }
      return rejectWithValue("Failed to send OTP");
    }
  },
);